export const SectionHead = ({ eyebrow, title, text, heat = false, light = false }) => (
  <div className="max-w-2xl flex flex-col gap-4">
    <span className={heat ? "eyebrow-heat" : "eyebrow"}>{eyebrow}</span>
    <h2 className={`font-display text-3xl sm:text-4xl lg:text-[2.75rem] font-extrabold tracking-tight leading-[1.1] ${light ? "text-white" : "text-slate-900"}`}>
      {title}
    </h2>
    {text && <p className={`text-base md:text-lg leading-relaxed ${light ? "text-sky-100/80" : "text-slate-600"}`}>{text}</p>}
  </div>
);
